import { SNAPGRID } from './commonConstants'

export const snapToGrid = (value: number): number => {
  return Math.round(value / SNAPGRID) * SNAPGRID
}
